import { fetchConfig, debounce } from '@lib/section-utils';
import {
  PUB_SUB_EVENTS,
  subscribe,
  publish,
  ON_CHANGE_DEBOUNCE_TIMER,
  shippingconversion,
  renderShipping,
  renderGiftWrapp,
  trapFocus,
} from '@lib/pubsub';
export class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button ').addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

export class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    const customElements = document.querySelector('cart-drawer') || document.querySelector('cart-items');
    const amount = customElements?.querySelector('[data-total-amount]');
    const cartElement = customElements?.querySelector('[data-cart-shippingbar]');

    if (amount && cartElement) {
      const total_amount = amount.getAttribute('data-total-amount');
      cartElement.setAttribute('data-cart-total', total_amount);
    }

    shippingconversion();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    if (event.target.name == 'attributes[gift_wrapping]') return;
    if (!event.target) return;
    const inputValue = parseInt(event.target.value);
    if (!inputValue) return;
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  async onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        this.sectionDrawerId = cartDrawer.getAttribute('data-section');

        return fetch(`${Theme.routes.cart_url}?section_id=${this.sectionDrawerId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const selectors = [
              '.cart-drawers',
              '[data-product-recommendations]',
              '[data-product-recommendations-mobile]',
            ];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            renderShipping();
            shippingconversion();
            renderGiftWrapp();

            setTimeout(() => {
              trapFocus(cartDrawer);
            }, 2000);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    } else {
      return fetch(`${Theme.routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['[main-cart-items]', '[data-main-cart-footer]'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          renderShipping();
          shippingconversion();
          renderGiftWrapp();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.querySelector('.main-cart-list')
          ? document.querySelector('.main-cart-list').dataset.id
          : null,
        selector: '[data-js-contents]',
      },
      {
        id: 'main-cart-footer',
        section: document.querySelector('[data-main-cart-footer]')
          ? document.querySelector('[data-main-cart-footer]').dataset.id
          : null,
        selector: '[data-js-summary]',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    if (event.type == 'click') {
      this.enableLoading(line);
    }
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${Theme.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartWrapper = document.querySelector('[data-main-cart-items]');
        document.querySelector('[data-cart-icon-bubble]').textContent = parsedState.item_count;
        if (cartDrawerWrapper) {
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        }
        if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        //this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {})
      .finally(() => {
        this.disableLoading(line);

        renderShipping();
        shippingconversion();
        renderGiftWrapp();

        if (customElements.get('cart-drawer')) {
          const fouceCart = document.querySelector('cart-drawer');
          if (fouceCart) {
            setTimeout(() => {
              trapFocus(fouceCart);
            }, 2000);
          }
        }

        const gift_wrapping = document.querySelector('gift-wrapping');

        if (gift_wrapping) {
          this.cartItemsSize = parseInt(gift_wrapping.getAttribute('cart-items-size'));
          this.giftWrapsInCart = parseInt(gift_wrapping.getAttribute('gift-wraps-in-cart'));
          if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
            return gift_wrapping.removeGiftWrap();
          }
        }
      });
  }

  updateLiveRegions(line, message) {
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-Errors');
    errors.textContent = message;
    if (errors) {
      const errorWrapper = errors.closest('.error');
      if (errorWrapper) {
        errorWrapper.classList.remove('hidden');
        errorWrapper.removeAttribute('hidden'); // in case it's using the HTML attribute
      }
    }

    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const itemEl = document.querySelector(`[data-cart-item="${line}"]`);
    if (!itemEl) return;
    itemEl.classList.add('cart-item-removed');
  }

  disableLoading(line) {
    const itemEl = document.querySelector(`[data-cart-item="${line}"]`);
    if (!itemEl) return;
    itemEl.classList.remove('cart-item-removed');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${Theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));
  }

  connectedCallback() {
    // When the gift-wrapping checkbox is checked or unchecked.
    this.querySelector('[name="attributes[gift_wrapping]"]').addEventListener('change', (event) => {
      event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
    });

    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      return this.removeGiftWrap();
    }
  }

  setGiftWrap() {
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 1,
      },
      attributes: {
        gift_wrapping: true,
      },
    });

    this.fetchGiftWrap(body);

    this.setAttribute('gift-wraps-in-cart', 1);
  }

  removeGiftWrap() {
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0,
      },
      attributes: {
        gift_wrapping: false,
      },
    });

    this.fetchGiftWrap(body);
    this.setAttribute('gift-wraps-in-cart', 0);
  }

  fetchGiftWrap(body) {
    fetch(`${Theme.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
        const cartWrapper = document.querySelector('[data-main-cart-items]');
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartDrawerShipping = document.querySelector('cart-shipping');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartWrapper) cartWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerShipping) cartDrawerShipping.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
customElements.define('gift-wrapping', GiftWrapping);
